/* eslint-disable @typescript-eslint/no-extraneous-class */
export class SVGIcons {
    static getIcon(name: string, flip: boolean, colour: string) {
        switch (name) {
            case 'grader':
                return SVGIcons.grader(flip, colour);
            case 'dumptruck':
                return SVGIcons.dumpTruck(flip, colour);
            case 'pickup':
                return SVGIcons.pickup(flip, colour);
            case 'loader':
                return SVGIcons.loader(flip, colour);
            case 'plow':
                return SVGIcons.plow(flip, colour);
            case 'excavator':
                return SVGIcons.excavator(flip, colour);
            case 'suv':
                return SVGIcons.suv(flip, colour);
            case 'car':
                return SVGIcons.car(flip, colour);
            case 'atv':
                return SVGIcons.atv(flip, colour);
            case 'tractor':
                return SVGIcons.tractor(flip, colour);
            case 'camera':
                return SVGIcons.camera(colour);
            case 'stopsign':
                return SVGIcons.stopSign(colour);
            default:
                return SVGIcons.pickup(flip, colour);
        }
    }

    static stopSign(colour: string) {
        const width = '40';
        const height = '40';

        return (
            '<?xml version="1.0"?><svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '        <path id="Union" fill-rule="evenodd" d="M4.91421 0c-0.39782 0 -0.77935 0.158035 -1.06066 0.43934L0.43934 3.85355C0.158035 4.13486 0 4.51639 0 4.91421v4.17158c0 0.39782 0.158035 0.77935 0.43934 1.06061l3.41421 3.4143c0.28131 0.2813 0.66284 0.4393 1.06066 0.4393h4.17158c0.39782 0 0.77935 -0.158 1.06061 -0.4393l3.4143 -3.4143C13.842 9.86514 14 9.48361 14 9.08579V4.91421c0 -0.39782 -0.158 -0.77935 -0.4393 -1.06066L10.1464 0.43934C9.86514 0.158035 9.48361 0 9.08579 0H4.91421Z" clip-rule="evenodd" stroke-width="1" fill="' +
            colour +
            '" stroke="black"/></svg>'
        );
    }

    static camera(colour: string) {
        const width = '40';
        const height = '40';
        return (
            '<?xml version="1.0"?><svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '        <path d="M17 3.99872H14.54L13.43 2.33872C13.1562 1.92648 12.7846 1.5884 12.3484 1.35459C11.9122 1.12079 11.4249 0.998534 10.93 0.998718H9.07C8.57509 0.998534 8.08783 1.12079 7.65163 1.35459C7.21543 1.5884 6.84385 1.92648 6.57 2.33872L5.46 3.99872H3C2.20435 3.99872 1.44129 4.31479 0.87868 4.8774C0.316071 5.44001 0 6.20307 0 6.99872V14.9987C0 15.7944 0.316071 16.5574 0.87868 17.12C1.44129 17.6826 2.20435 17.9987 3 17.9987H17C17.7956 17.9987 18.5587 17.6826 19.1213 17.12C19.6839 16.5574 20 15.7944 20 14.9987V6.99872C20 6.20307 19.6839 5.44001 19.1213 4.8774C18.5587 4.31479 17.7956 3.99872 17 3.99872ZM18 14.9987C18 15.2639 17.8946 15.5183 17.7071 15.7058C17.5196 15.8934 17.2652 15.9987 17 15.9987H3C2.73478 15.9987 2.48043 15.8934 2.29289 15.7058C2.10536 15.5183 2 15.2639 2 14.9987V6.99872C2 6.7335 2.10536 6.47915 2.29289 6.29161C2.48043 6.10408 2.73478 5.99872 3 5.99872H6C6.16471 5.99787 6.32665 5.95634 6.47145 5.87784C6.61625 5.79933 6.73941 5.68628 6.83 5.54872L8.24 3.44872C8.33059 3.31116 8.45375 3.1981 8.59855 3.1196C8.74335 3.04109 8.90529 2.99957 9.07 2.99872H10.93C11.0947 2.99957 11.2567 3.04109 11.4015 3.1196C11.5462 3.1981 11.6694 3.31116 11.76 3.44872L13.17 5.54872C13.2606 5.68628 13.3838 5.79933 13.5285 5.87784C13.6733 5.95634 13.8353 5.99787 14 5.99872H17C17.2652 5.99872 17.5196 6.10408 17.7071 6.29161C17.8946 6.47915 18 6.7335 18 6.99872V14.9987ZM10 6.99872C9.20887 6.99872 8.43552 7.23331 7.77772 7.67284C7.11992 8.11237 6.60723 8.73708 6.30448 9.46798C6.00173 10.1989 5.92252 11.0032 6.07686 11.7791C6.2312 12.555 6.61216 13.2677 7.17157 13.8271C7.73098 14.3866 8.44372 14.7675 9.21964 14.9219C9.99556 15.0762 10.7998 14.997 11.5307 14.6942C12.2616 14.3915 12.8864 13.8788 13.3259 13.221C13.7654 12.5632 14 11.7898 14 10.9987C14 9.93785 13.5786 8.92044 12.8284 8.17029C12.0783 7.42015 11.0609 6.99872 10 6.99872ZM10 12.9987C9.60444 12.9987 9.21776 12.8814 8.88886 12.6617C8.55996 12.4419 8.30362 12.1295 8.15224 11.7641C8.00087 11.3986 7.96126 10.9965 8.03843 10.6085C8.1156 10.2206 8.30608 9.86421 8.58579 9.58451C8.86549 9.3048 9.22186 9.11432 9.60982 9.03715C9.99778 8.95998 10.3999 8.99958 10.7654 9.15096C11.1308 9.30233 11.4432 9.55868 11.6629 9.88758C11.8827 10.2165 12 10.6032 12 10.9987C12 11.5292 11.7893 12.0379 11.4142 12.4129C11.0391 12.788 10.5304 12.9987 10 12.9987Z" fill="' +
            colour +
            '" stroke="black"/></svg>'
        );
    }

    /*
    static right_arrow(colour: string, width: number, height: number) {
        return '<?xml version="1.0" encoding="utf-8"?><svg width="'+width+'px" height="'+height+'px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.7055 18.9112C14.2784 18.7306 14 18.3052 14 17.8333V15H3C2.44772 15 2 14.5523 2 14V10C2 9.44772 2.44772 9 3 9H14V6.1667C14 5.69483 14.2784 5.26942 14.7055 5.08884C15.1326 4.90826 15.6241 5.00808 15.951 5.34174L21.6653 11.175C22.1116 11.6307 22.1116 12.3693 21.6653 12.825L15.951 18.6583C15.6241 18.9919 15.1326 19.0917 14.7055 18.9112Z" fill="' + colour + '" stroke="black"/></svg>'
    }
*/
    static right_arrow(_colour: string, _width: number, _height: number) {
        return '<?xml version="1.0" encoding="utf-8"?><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="-3 -3 22 22"><g id="deeditor_bgCarrier" stroke-width="0"><rect id="dee_c_e" x="2" y="3" width="12" height="12" rx="38.4" fill="#FFFFFF" strokewidth="0"/></g><path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" fill="#00AA00"/></svg>';
    }

    static plow_truck(colour: string, width: number, height: number) {
        return (
            '<?xml version="1.0"?><svg width="' +
            width +
            'px" height="' +
            height +
            'px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path style="text-indent:0;text-align:start;line-height:normal;text-transform:none;block-progression:tb;-inkscape-font-specification:Bitstream Vera Sans" d="M 8.875 5 L 8.625 5.15625 L 7.53125 5.84375 L 7.21875 6.03125 L 7.09375 6.34375 L 6.40625 8.375 L 2.8125 9.03125 L 2 9.15625 L 2 10 L 2 19 C 2 19.963537 2.1688134 20.837627 2.53125 21.5625 C 2.8936866 22.287373 3.5453462 23 4.5 23 C 5.2429857 23 5.8050793 22.564379 6.1875 22.03125 L 9.15625 22.6875 C 9.2712727 23.274786 9.4485839 23.803418 9.6875 24.28125 C 10.140419 25.187088 10.907275 26 12 26 C 12.084365 26 12.169515 25.97811 12.25 25.96875 L 28.9375 27 L 30 27.0625 L 30 26 L 30 19 L 30 18 L 29 18 L 28 18 L 28 16 C 28 14.782736 27.252968 13.677128 26.125 13.21875 L 23.8125 12.25 L 23.0625 9.5 C 22.832258 8.6266698 22.059589 8 21.15625 8 L 14.90625 8 L 14.84375 8 L 14.75 8 L 12.6875 8.3125 C 11.718225 8.4611619 11 9.33267 11 10.3125 L 11 16.28125 C 10.68081 16.454362 10.423168 16.716831 10.1875 17 L 8.1875 17 L 8.15625 17 L 6.59375 16.6875 C 6.5575928 16.601547 6.5098511 16.519702 6.46875 16.4375 C 6.1063134 15.712627 5.4546538 15 4.5 15 C 4.3226446 15 4.1565285 15.017799 4 15.0625 L 4 10.8125 L 7.3125 10.25 L 7.90625 10.125 L 8.09375 9.59375 L 8.875 7.34375 L 9.4375 7 L 21.59375 7 L 21.59375 5 L 9.15625 5 L 8.875 5 z M 16.15625 10 L 21.15625 10 L 21.6875 12 L 16.59375 12 L 16.15625 10 z M 14.15625 10.125 L 14.84375 13.21875 L 15.03125 14 L 15.8125 14 L 22.75 14 L 25.375 15.0625 C 25.753032 15.216122 26 15.591264 26 16 L 26 16.09375 C 25.413588 16.29759 25 16.844162 25 17.5 C 25 17.672589 25.040108 17.845681 25.09375 18 L 19.90625 18 C 19.959892 17.845681 20 17.672589 20 17.5 C 20 16.671573 19.328427 16 18.5 16 C 17.671573 16 17 16.671573 17 17.5 C 17 17.672589 17.040108 17.845681 17.09375 18 L 14.4375 18 C 14.39726 17.90676 14.356964 17.807678 14.3125 17.71875 C 14.01469 17.12313 13.572664 16.591834 13 16.28125 L 13 10.3125 L 14.15625 10.125 z M 4.5 17.0625 C 4.5364459 17.102183 4.5775894 17.155179 4.65625 17.3125 C 4.8367066 17.673413 5 18.306683 5 19 C 5 19.693317 4.8367066 20.326587 4.65625 20.6875 C 4.5775894 20.844821 4.5364459 20.897817 4.5 20.9375 C 4.4635541 20.897817 4.4224106 20.844821 4.34375 20.6875 C 4.1632934 20.326587 4 19.693317 4 19 C 4 18.306683 4.1632934 17.673413 4.34375 17.3125 C 4.4224106 17.155179 4.4635541 17.102183 4.5 17.0625 z M 12 18 C 12.01184 18 12.260311 18.08312 12.53125 18.625 C 12.802189 19.166878 13 20.030541 13 21 C 13 21.969459 12.802189 22.833122 12.53125 23.375 C 12.260311 23.916878 12.011844 24 12 24 C 11.988156 24 11.739689 23.916878 11.46875 23.375 C 11.197811 22.833122 11 21.969459 11 21 C 11 20.030541 11.197811 19.166878 11.46875 18.625 C 11.739689 18.083122 11.988156 18 12 18 z M 7 18.78125 L 7.96875 18.96875 L 8.0625 19 L 8.15625 19 L 9.25 19 C 9.1246082 19.502251 9.0242974 20.029503 9 20.59375 L 6.90625 20.125 C 6.9632774 19.768081 7 19.390232 7 19 C 7 18.926826 7.0019581 18.853366 7 18.78125 z M 14.9375 20 L 28 20 L 28 24.9375 L 14.40625 24.09375 C 14.801648 23.22027 15 22.156903 15 21 C 15 20.655985 14.973282 20.325314 14.9375 20 z" fill="' +
            colour +
            '" stroke="black"/></svg>'
        );
    }
    static square(colour: string, width: number, height: number) {
        return (
            '<?xml version="1.0"?><svg width="' +
            width +
            'px" height="' +
            height +
            'px" xmlns="http://www.w3.org/2000/svg"><rect width="' +
            width +
            'px" height="' +
            height +
            'px" fill="' +
            colour +
            '" stroke="black" /></svg>'
        );
    }

    /** Creates a triangle SVG icon with the specified colour, width, and height.
     *
     * @param colour
     * @param width
     * @param height
     * @returns
     */
    static triangle(colour: string, width: number, height: number) {
        return (
            '<?xml version="1.0"?><svg width="' +
            width +
            'px" height="' +
            height +
            'px" xmlns="http://www.w3.org/2000/svg"><polygon points="' +
            width / 2 +
            ',0 ' +
            width +
            ',' +
            height +
            ' 0,' +
            height +
            '" fill="' +
            colour +
            '" stroke="black" /></svg>'
        );
    }

    /*
    static idle(colour: string, width: number, height: number) {
        return  '<?xml version="1.0"?><svg width="'+width+'px" height="'+height+'px"  fill="' + colour + '" stroke="black" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g id="Group_22" data-name="Group 22" transform="translate(-670.002 -321.695)"><path id="Path_360" data-name="Path 360" d="M686,353.7a16,16,0,1,0-16-16A16,16,0,0,0,686,353.7Zm0-28a12,12,0,1,1-12,12A12,12,0,0,1,686,325.7Z"/><rect id="Rectangle_32" data-name="Rectangle 32" width="3" height="9.999" transform="translate(681.002 332.696)"/><rect id="Rectangle_33" data-name="Rectangle 33" width="3" height="9.999" transform="translate(688.002 332.696)"/></g></svg>';
    }
*/

    static idle(_colour: string, _width: number, _height: number) {
        return '<?xml version="1.0" encoding="utf-8"?><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="-3 -3 38 38" fill="#0000AA"><g id="deeditor_bgCarrier" stroke-width="0"><rect id="dee_c_e" x="-3" y="-3" width="38" height="38" rx="38.4" fill="#ffffff" strokewidth="0"/></g><g><path d="M 16,0C 7.164,0,0,7.164,0,16s 7.164,16, 16,16s 16-7.164, 16-16S 24.836,0, 16,0z M 14,20c0,1.104-0.896,2-2,2s-2-0.896-2-2L 10,12 c0-1.104, 0.896-2, 2-2s 2,0.896, 2,2L 14,20 z M 22,20c0,1.104-0.896,2-2,2s-2-0.896-2-2L 18,12 c0-1.104, 0.896-2, 2-2s 2,0.896, 2,2L 22,20 z" fill="#0000AA"/></g></svg>';
    }

    static grader(flip: boolean, colour: string) {
        let svg = `<?xml version="1.0" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"
 "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="40" height="40" viewBox="0 0 512.000000 512.000000"
 preserveAspectRatio="xMidYMid meet">`;

        if (flip == true) {
            svg += `<g transform="translate(0.000000,0.000000) scale(0.100000,0.100000)" `;
        } else {
            svg += '<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" ';
        }
        svg +=
            ` fill='` +
            colour +
            `' stroke="black"  stroke-width="50" >
<path d="M2005 3909 c-57 -16 -139 -74 -176 -123 -69 -92 -69 -88 -69 -667 0
-506 1 -520 20 -539 19 -19 33 -20 460 -20 422 0 441 1 459 19 11 11 22 35 26
53 18 108 155 1170 155 1205 0 30 -6 49 -20 63 -19 19 -33 20 -422 19 -222 0
-416 -5 -433 -10z m698 -341 c19 -26 19 -28 2 -190 -20 -193 -29 -234 -55
-248 -10 -6 -94 -10 -193 -10 -161 0 -177 2 -216 23 -158 83 -158 351 0 435
41 21 51 22 242 20 l200 -3 20 -27z"/>
<path d="M980 3500 c-13 -13 -20 -33 -20 -60 0 -34 8 -48 59 -105 73 -80 90
-127 98 -267 l6 -108 -215 0 c-300 0 -310 -4 -581 -198 -82 -58 -170 -129
-195 -157 -81 -89 -132 -216 -132 -332 0 -53 3 -64 22 -77 34 -24 53 -20 105
27 146 129 310 183 504 165 222 -20 429 -178 518 -395 23 -57 31 -68 51 -68
19 0 28 11 51 67 153 374 599 516 936 297 34 -22 97 -78 140 -125 74 -79 82
-84 120 -84 33 0 53 9 108 49 37 27 76 63 86 80 18 30 21 31 89 31 l70 0 0
-260 c0 -242 1 -261 19 -279 10 -10 64 -34 120 -52 l100 -33 11 -48 c15 -60
75 -154 126 -196 69 -57 138 -85 224 -90 69 -4 80 -2 99 17 28 28 29 93 2 120
-11 11 -41 23 -68 27 -136 19 -222 109 -223 232 0 126 88 219 223 237 27 4 57
15 68 26 27 27 26 92 -2 120 -32 32 -154 23 -235 -16 -76 -37 -153 -114 -187
-187 -15 -32 -30 -58 -34 -58 -3 0 -23 5 -44 12 l-39 11 0 210 0 209 348 -5
c384 -6 431 -12 580 -73 118 -49 132 -47 212 29 37 34 88 80 114 103 36 32 46
47 46 72 0 49 -35 77 -175 140 -282 127 -310 132 -824 132 -461 0 -417 8 -465
-87 -14 -29 -35 -57 -45 -63 -13 -6 -188 -10 -501 -10 -533 0 -538 0 -559 60
-6 20 -11 100 -11 197 l0 165 -29 29 -29 29 -170 0 -170 0 -4 143 c-3 139 -4
143 -39 217 -23 48 -57 98 -95 138 -55 57 -63 62 -102 62 -29 0 -48 -6 -62
-20z m-125 -725 c22 -21 25 -33 25 -95 0 -62 -3 -74 -25 -95 -15 -16 -36 -25
-55 -25 -19 0 -40 9 -55 25 -22 21 -25 33 -25 95 0 62 3 74 25 95 15 16 36 25
55 25 19 0 40 -9 55 -25z m320 0 c22 -21 25 -33 25 -95 0 -62 -3 -74 -25 -95
-15 -16 -36 -25 -55 -25 -19 0 -40 9 -55 25 -22 21 -25 33 -25 95 0 62 3 74
25 95 15 16 36 25 55 25 19 0 40 -9 55 -25z m320 0 c22 -21 25 -33 25 -95 0
-62 -3 -74 -25 -95 -15 -16 -36 -25 -55 -25 -19 0 -40 9 -55 25 -22 21 -25 33
-25 95 0 62 3 74 25 95 15 16 36 25 55 25 19 0 40 -9 55 -25z"/>
<path d="M374 2292 c-169 -59 -287 -177 -346 -346 -24 -69 -28 -97 -28 -186 0
-169 51 -291 171 -408 57 -56 154 -111 238 -136 88 -26 236 -22 328 9 172 58
295 179 355 349 24 69 28 97 28 186 0 89 -4 117 -28 186 -59 168 -178 287
-346 346 -69 24 -97 28 -186 28 -89 0 -117 -4 -186 -28z m269 -308 c85 -29
157 -132 157 -224 0 -125 -114 -240 -238 -240 -65 0 -115 22 -167 75 -102 101
-102 229 0 330 72 73 152 92 248 59z"/>
<path d="M1654 2292 c-169 -59 -287 -177 -346 -346 -24 -69 -28 -97 -28 -186
0 -169 51 -291 171 -408 57 -56 154 -111 238 -136 88 -26 236 -22 328 9 172
58 295 179 355 349 24 69 28 97 28 186 0 89 -4 117 -28 186 -59 168 -178 287
-346 346 -69 24 -97 28 -186 28 -89 0 -117 -4 -186 -28z m269 -308 c85 -29
157 -132 157 -224 0 -125 -114 -240 -238 -240 -65 0 -115 22 -167 75 -102 101
-102 229 0 330 72 73 152 92 248 59z"/>
<path d="M4374 2292 c-169 -59 -287 -177 -346 -346 -24 -69 -28 -97 -28 -186
0 -169 51 -291 171 -408 57 -56 154 -111 238 -136 88 -26 236 -22 328 9 172
58 295 179 355 349 24 69 28 97 28 186 0 89 -4 117 -28 186 -59 168 -178 287
-346 346 -69 24 -97 28 -186 28 -89 0 -117 -4 -186 -28z m269 -308 c85 -29
157 -132 157 -224 0 -125 -114 -240 -238 -240 -126 0 -242 115 -242 240 0 63
23 114 75 165 72 73 152 92 248 59z"/>
</g>
</svg>`;

        return svg;
    }

    static dumpTruck(flip: boolean, colour: string) {
        let svg = `<?xml version="1.0" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"
 "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="40" height="40" viewBox="0 0 512.000000 512.000000"
 preserveAspectRatio="xMidYMid meet">`;
        if (flip == true) {
            svg += `<g transform="translate(0.000000,0.000000) scale(0.100000,0.100000)" `;
        } else {
            svg += '<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" ';
        }
        svg +=
            ` fill='` +
            colour +
            `' stroke="black" stroke-width="50">

        <path d="M2763 3926 c-120 -238 -147 -275 -220 -295 -26 -7 -447 -11 -1290
-11 l-1253 0 0 -795 0 -795 1590 0 1590 0 2 908 3 907 23 37 c13 20 40 47 60
60 37 23 40 23 420 26 l382 3 0 89 0 90 -597 0 -598 0 -112 -224z"/>
<path d="M3700 2740 l0 -710 710 0 710 0 0 434 0 433 -197 276 -198 276 -512
1 -513 0 0 -710z m892 410 c14 -10 77 -88 139 -172 108 -144 114 -154 114
-199 0 -39 -5 -53 -30 -79 -16 -17 -45 -35 -65 -41 -22 -7 -154 -9 -360 -7
-360 3 -358 3 -394 71 -15 28 -17 56 -14 205 l3 174 37 34 38 34 254 0 c237 0
255 -1 278 -20z"/>
<path d="M0 1680 l0 -180 94 0 94 0 12 53 c19 79 61 165 119 240 l52 67 -186
0 -185 0 0 -180z"/>
<path d="M700 1849 c-71 -14 -162 -64 -220 -121 -147 -146 -173 -383 -60 -556
47 -73 108 -126 190 -166 61 -29 72 -31 180 -31 96 0 124 4 170 22 301 123
375 513 140 737 -109 105 -249 145 -400 115z m169 -284 c126 -65 125 -243 -2
-304 -53 -26 -90 -26 -143 -2 -126 57 -132 228 -10 302 38 23 115 25 155 4z"/>
<path d="M1760 1849 c-128 -25 -249 -122 -308 -248 -31 -63 -37 -88 -40 -161
-7 -138 28 -234 118 -334 36 -39 74 -67 127 -93 66 -32 86 -37 165 -41 111 -6
195 15 276 68 190 122 256 377 151 582 -30 58 -119 150 -177 181 -90 49 -208
66 -312 46z m168 -283 c58 -30 94 -87 94 -151 0 -122 -115 -203 -227 -161
-137 53 -149 229 -21 307 37 23 115 25 154 5z"/>
<path d="M2280 1852 c0 -5 14 -21 31 -38 57 -54 121 -183 144 -286 3 -16 10
-28 15 -28 6 0 10 69 10 180 l0 180 -100 0 c-55 0 -100 -4 -100 -8z"/>
<path d="M2640 1680 l0 -180 95 0 95 0 0 180 0 180 -95 0 -95 0 0 -180z"/>
<path d="M3000 1680 l0 -180 90 0 90 0 0 180 0 180 -90 0 -90 0 0 -180z"/>
<path d="M3350 1680 l0 -180 183 0 183 0 23 78 c26 88 66 164 122 228 22 25
39 47 39 50 0 2 -124 4 -275 4 l-275 0 0 -180z"/>
<path d="M4232 1849 c-112 -22 -240 -117 -295 -217 -126 -232 -37 -508 202
-625 63 -31 71 -32 186 -32 114 0 123 2 185 31 176 85 270 245 258 439 -17
269 -267 457 -536 404z m166 -283 c63 -33 108 -114 97 -175 -10 -55 -51 -110
-98 -132 -54 -24 -91 -24 -144 2 -125 60 -130 226 -9 300 37 23 115 25 154 5z"/>
<path d="M4801 1793 c58 -75 100 -161 119 -240 l12 -53 94 0 94 0 0 180 0 180
-185 0 -186 0 52 -67z"/>
</g>
</svg>`;
        return svg;
    }

    static pickup(flip: boolean, colour: string) {
        let svg = `<?xml version="1.0" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"
 "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="40" height="40" viewBox="0 0 512.000000 512.000000"
 preserveAspectRatio="xMidYMid meet">`;

        if (flip == true) {
            svg += `<g transform="translate(0.000000,0.000000) scale(0.100000,0.100000)" `;
        } else {
            svg += '<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" ';
        }
        svg +=
            ` fill='` +
            colour +
            `' stroke="black" stroke-width="50" >
<path d="M2275 3826 c-117 -37 -217 -122 -270 -229 -19 -40 -40 -96 -45 -126
-6 -33 -10 -353 -10 -822 l0 -769 763 0 763 0 17 68 c82 319 400 551 727 529
320 -21 583 -251 655 -571 6 -28 7 -29 57 -23 63 8 119 43 155 99 l28 42 0
390 c0 358 -2 394 -18 427 -31 62 -85 116 -145 146 l-57 28 -342 5 -343 5
-320 350 c-176 193 -343 367 -372 387 -29 21 -82 47 -117 58 -60 19 -89 20
-575 19 -383 0 -521 -4 -551 -13z m505 -551 l0 -255 -261 0 -260 0 3 203 c3
185 5 205 24 235 43 69 55 72 287 72 l207 0 0 -255z m539 241 c24 -13 432
-447 455 -483 6 -10 -65 -13 -338 -13 l-346 0 0 255 0 255 100 0 c68 0 110 -5
129 -14z"/>
<path d="M240 3011 c-96 -19 -172 -80 -216 -175 -24 -51 -24 -52 -24 -451 0
-382 1 -401 20 -433 25 -40 75 -72 115 -72 30 0 32 2 43 60 18 85 94 227 160
300 314 348 863 306 1120 -85 40 -61 85 -171 108 -262 2 -8 21 -13 49 -13 l45
0 0 570 0 570 -692 -1 c-381 -1 -709 -4 -728 -8z"/>
<path d="M718 2241 c-151 -49 -259 -152 -318 -306 -33 -83 -33 -242 -1 -329
44 -121 131 -221 241 -275 87 -44 138 -54 253 -49 99 3 109 6 188 45 217 108
322 339 261 574 -43 163 -171 292 -341 343 -74 22 -210 20 -283 -3z m238 -316
c90 -53 118 -168 61 -253 -98 -149 -333 -80 -331 98 2 139 151 225 270 155z"/>
<path d="M4030 2241 c-210 -67 -341 -249 -341 -474 -1 -204 122 -385 308 -458
80 -31 237 -38 319 -14 150 43 275 159 327 303 25 72 34 206 17 281 -38 173
-192 331 -361 370 -69 16 -207 12 -269 -8z m223 -307 c68 -34 107 -95 107
-164 0 -150 -184 -236 -296 -138 -46 41 -64 77 -64 132 0 56 14 93 48 130 52
55 141 72 205 40z"/>
</g>
</svg>`;
        return svg;
    }

    static loader(flip: boolean, colour: string) {
        let svg = `<?xml version="1.0" standalone="no"?>
    <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"
     "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
     width="40" height="40" viewBox="0 0 512.000000 512.000000"
     preserveAspectRatio="xMidYMid meet">`;

        if (flip == true) {
            svg += `<g transform="translate(0.000000,0.000000) scale(0.100000,0.100000)" `;
        } else {
            svg += '<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" ';
        }
        svg +=
            ` fill='` +
            colour +
            `' stroke="black"  stroke-width="50">
    <path d="M1556 4045 c-57 -20 -87 -45 -113 -95 -23 -43 -23 -47 -23 -417 l0
    -373 -230 0 -230 0 0 73 c0 132 -45 246 -126 317 -42 37 -86 40 -108 8 -23
    -33 -21 -42 30 -99 67 -76 84 -118 84 -216 l0 -83 -162 0 c-100 0 -185 -5
    -219 -14 -115 -27 -210 -105 -263 -216 -31 -65 -31 -66 -34 -257 l-4 -193 286
    0 286 0 67 45 c127 85 275 129 438 128 158 -1 320 -50 440 -134 l56 -39 651 0
    651 0 -6 138 c-6 156 -25 229 -81 316 -66 103 -204 198 -309 212 -25 4 -49 9
    -54 13 -5 3 -62 173 -127 376 -65 204 -126 388 -136 411 -22 51 -71 90 -130
    103 -71 17 -586 13 -634 -4z m114 -495 l0 -390 -65 0 -65 0 0 365 0 366 25 24
    c18 18 35 25 65 25 l40 0 0 -390z m524 367 c14 -14 36 -64 54 -123 18 -54 74
    -230 125 -391 l94 -291 -49 -66 c-26 -37 -60 -71 -74 -76 -37 -14 -297 -13
    -329 2 -14 6 -46 40 -71 75 -43 60 -101 103 -139 103 -13 0 -15 46 -15 395 l0
    395 190 0 c186 0 191 -1 214 -23z"/>
    <path d="M3134 2798 c4 -13 10 -75 13 -138 l6 -115 143 0 c79 0 143 2 142 5
    -2 3 -14 36 -28 74 -13 37 -40 86 -59 108 -43 50 -120 88 -180 88 -40 0 -43
    -2 -37 -22z"/>
    <path d="M1065 2514 c-214 -52 -403 -226 -478 -441 -90 -264 -2 -580 210 -748
    215 -170 495 -201 738 -81 224 111 362 324 373 576 8 209 -52 365 -198 511
    -138 139 -286 199 -485 198 -55 0 -127 -7 -160 -15z m297 -361 c65 -29 129
    -92 164 -160 25 -50 29 -69 29 -138 0 -71 -4 -89 -33 -147 -58 -117 -161 -182
    -292 -182 -62 -1 -85 4 -132 27 -141 69 -218 216 -189 359 24 112 113 215 220
    252 62 21 171 16 233 -11z"/>
    <path d="M1140 2067 c-89 -42 -140 -122 -140 -216 1 -209 252 -310 397 -161
    47 48 66 106 61 183 -5 77 -36 132 -100 174 -35 24 -53 28 -117 30 -44 1 -87
    -3 -101 -10z"/>
    <path d="M4417 2430 c-147 -57 -237 -192 -237 -355 l0 -75 -61 0 c-59 0 -61
    -1 -55 -22 39 -133 44 -260 18 -390 l-18 -88 57 0 56 0 5 -82 c6 -110 38 -177
    118 -251 99 -93 130 -100 418 -105 215 -3 246 -2 268 13 22 14 25 23 22 56
    l-4 39 39 0 c57 0 77 14 77 55 0 46 -29 65 -100 65 l-56 0 -159 508 c-87 279
    -167 531 -177 560 -33 89 -105 114 -211 72z"/>
    <path d="M3195 2419 c-252 -39 -462 -214 -545 -453 -63 -185 -41 -400 61 -573
    55 -93 171 -202 270 -251 113 -56 192 -75 314 -75 191 0 346 64 480 198 134
    134 198 289 198 480 0 121 -18 200 -75 315 -78 160 -252 300 -430 344 -77 20
    -201 27 -273 15z m220 -370 c76 -28 156 -108 184 -184 82 -218 -74 -445 -304
    -445 -126 0 -240 71 -295 185 -31 64 -39 174 -17 239 33 95 111 177 205 211
    58 21 162 18 227 -6z"/>
    <path d="M3219 1964 c-85 -26 -159 -128 -159 -219 0 -52 31 -124 71 -164 101
    -100 279 -86 355 28 87 132 27 313 -119 356 -61 18 -88 18 -148 -1z"/>
    <path d="M15 2360 c-21 -40 -21 -256 0 -306 15 -36 147 -230 212 -311 43 -54
    107 -92 173 -102 l52 -8 -6 31 c-4 17 -9 86 -12 152 -10 188 27 322 132 481
    30 44 54 84 54 87 0 3 -133 6 -295 6 l-294 0 -16 -30z"/>
    <path d="M1840 2384 c0 -3 20 -34 45 -69 99 -138 146 -288 146 -460 -1 -60 -5
    -128 -11 -150 -20 -81 -39 -75 234 -75 l243 0 -4 88 c-12 218 92 466 257 616
    28 24 50 47 50 50 0 3 -216 6 -480 6 -264 0 -480 -3 -480 -6z"/>
    </g>
    </svg>`;
        return svg;
    }

    static plow(flip: boolean, colour: string) {
        let svg = `<?xml version="1.0" standalone="no"?>
    <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"
     "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
     width="40" height="40" viewBox="0 0 512.000000 512.000000"
     preserveAspectRatio="xMidYMid meet">`;

        if (flip == true) {
            svg += `<g transform="translate(0.000000,0.000000) scale(0.100000,0.100000)" `;
        } else {
            svg += '<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" ';
        }
        svg +=
            ` fill='` +
            colour +
            `' stroke="black"  stroke-width="50" >
    <path d="M2618 3903 c-9 -10 -60 -97 -113 -194 -67 -123 -105 -180 -122 -188
    -17 -8 -338 -11 -1117 -11 l-1093 0 -21 -23 c-22 -23 -22 -29 -22 -323 l0
    -299 84 -295 83 -295 1272 -3 1271 -2 0 645 0 646 25 24 c22 23 32 25 118 25
    80 0 98 3 121 21 25 20 26 23 26 135 0 164 17 154 -268 154 -205 0 -230 -2
    -244 -17z m-1888 -713 c19 -19 20 -33 20 -300 0 -267 -1 -281 -20 -300 -11
    -11 -27 -20 -35 -20 -8 0 -24 9 -35 20 -19 19 -20 33 -20 304 0 283 0 285 22
    300 30 21 44 20 68 -4z m522 3 c17 -15 18 -38 18 -301 0 -252 -2 -288 -17
    -304 -23 -25 -48 -22 -72 8 -20 26 -21 39 -21 294 0 255 1 268 21 294 24 30
    45 33 71 9z m528 -3 c19 -19 20 -33 20 -300 0 -267 -1 -281 -20 -300 -24 -24
    -38 -25 -68 -4 -22 15 -22 17 -22 304 0 287 0 289 22 304 30 21 44 20 68 -4z
    m522 3 c17 -15 18 -38 18 -301 0 -252 -2 -288 -17 -304 -23 -25 -48 -22 -72 8
    -20 26 -21 39 -21 294 0 255 1 268 21 294 24 30 45 33 71 9z"/>
    <path d="M2998 3383 c-15 -10 -31 -24 -35 -33 -5 -8 -10 -278 -13 -600 l-5
    -585 -1322 -3 -1323 -2 0 -232 c0 -214 2 -235 21 -274 23 -48 69 -82 124 -91
    l35 -6 0 77 c0 84 24 171 65 236 63 100 184 179 306 200 172 30 366 -68 452
    -228 35 -64 61 -182 52 -239 l-6 -43 39 0 39 0 5 95 c5 84 10 104 41 168 139
    280 483 340 703 122 91 -91 144 -227 132 -340 l-6 -45 493 0 493 0 -6 45 c-12
    109 44 252 134 342 178 178 457 169 631 -20 75 -81 113 -181 113 -299 l0 -68
    100 0 c54 0 110 5 123 11 25 11 47 47 47 75 0 12 16 14 96 12 l96 -3 18 -55
    c28 -88 49 -130 106 -217 70 -106 153 -193 182 -193 28 0 72 42 72 69 0 11
    -23 46 -51 78 -195 220 -251 431 -165 619 29 63 106 148 157 175 52 26 67 80
    31 112 -45 41 -127 4 -219 -97 -76 -82 -120 -183 -138 -308 l-6 -48 -90 0 -89
    0 0 74 0 73 -89 5 c-66 4 -99 11 -127 27 -100 56 -124 185 -51 268 43 49 82
    63 177 63 76 0 80 1 80 23 0 38 -46 123 -90 167 -47 47 -120 84 -195 100 l-50
    10 -69 283 c-37 155 -77 303 -88 330 -26 59 -110 138 -175 163 -42 16 -88 19
    -388 21 -308 3 -343 2 -367 -14z m665 -187 c18 -7 46 -29 63 -47 26 -30 37
    -65 87 -269 76 -313 73 -294 48 -319 -20 -20 -30 -21 -267 -21 -297 0 -320 4
    -390 74 -68 69 -74 97 -74 350 0 193 1 207 20 226 19 19 33 20 250 20 171 0
    239 -3 263 -14z m-421 -773 c25 -22 23 -59 -4 -77 -24 -17 -153 -23 -174 -8
    -23 15 -35 51 -24 71 14 26 24 29 109 30 56 1 79 -3 93 -16z"/>
    <path d="M3242 2916 c3 -169 5 -187 24 -213 37 -50 53 -53 277 -53 179 0 207
    2 207 15 0 38 -94 402 -108 418 -13 15 -37 17 -209 17 l-194 0 3 -184z"/>
    <path d="M4247 2172 c-21 -23 -22 -76 -1 -96 12 -12 36 -16 100 -16 l84 0 0
    65 0 65 -83 0 c-69 0 -87 -3 -100 -18z"/>
    <path d="M834 1956 c-67 -16 -113 -46 -168 -107 -55 -62 -76 -121 -76 -218 0
    -60 5 -87 26 -131 54 -118 148 -181 280 -188 105 -6 166 14 234 75 63 56 95
    111 110 187 48 234 -172 442 -406 382z m136 -221 c80 -42 77 -161 -6 -200 -42
    -20 -62 -19 -101 5 -128 77 -25 263 107 195z"/>
    <path d="M1781 1955 c-70 -20 -111 -46 -160 -102 -60 -67 -84 -140 -79 -234
    10 -179 128 -297 304 -307 149 -8 254 50 316 175 30 61 33 76 32 153 0 67 -5
    95 -23 131 -72 149 -237 227 -390 184z m139 -220 c90 -46 77 -177 -21 -206
    -37 -11 -46 -11 -78 7 -50 27 -77 82 -61 129 24 72 96 103 160 70z"/>
    <path d="M3652 1960 c-59 -12 -137 -57 -174 -99 -86 -98 -109 -248 -56 -362
    32 -69 88 -127 154 -160 42 -21 63 -24 149 -24 92 0 104 2 154 30 68 38 125
    102 152 174 29 78 24 194 -14 267 -66 129 -222 204 -365 174z m137 -235 c42
    -36 56 -83 37 -129 -15 -37 -67 -76 -99 -76 -34 0 -88 32 -102 61 -56 108 72
    220 164 144z"/>
    </g>
    </svg>`;
        return svg;
    }

    static excavator(flip: boolean, colour: string) {
        let svg = `<?xml version="1.0" standalone="no"?>
    <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"
     "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
     width="40" height="40" viewBox="0 0 512.000000 512.000000"
     preserveAspectRatio="xMidYMid meet">`;

        if (flip == true) {
            svg += `<g transform="translate(0.000000,0.000000) scale(0.100000,0.100000)" `;
        } else {
            svg += '<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" ';
        }
        svg +=
            ` fill='` +
            colour +
            `' stroke="black"  stroke-width="50" >    
    <path d="M4174 4960 c-118 -17 -218 -87 -275 -192 -32 -60 -34 -68 -33 -158
    l1 -95 307 -845 c169 -465 308 -846 310 -847 1 -1 26 10 56 25 53 26 61 27
    218 27 102 0 162 4 162 10 0 5 -78 425 -174 931 -151 805 -177 928 -202 973
    -56 104 -145 157 -294 176 -14 1 -48 -1 -76 -5z m116 -350 c11 -11 20 -33 20
    -50 0 -17 -9 -39 -20 -50 -11 -11 -33 -20 -50 -20 -17 0 -39 9 -50 20 -11 11
    -20 33 -20 50 0 17 9 39 20 50 11 11 33 20 50 20 17 0 39 -9 50 -20z"/>
    <path d="M3020 4347 c-366 -151 -683 -283 -706 -295 -103 -53 -213 -171 -277
    -297 -29 -59 -117 -287 -117 -306 0 -5 190 -9 485 -9 l485 0 20 40 c11 22 34
    55 51 74 17 20 217 153 460 307 312 197 429 275 425 286 -34 88 -111 309 -122
    348 -8 28 -14 67 -14 88 0 23 -5 37 -12 37 -7 0 -312 -123 -678 -273z"/>
    <path d="M1760 3273 c-8 -3 -32 -16 -52 -30 -73 -49 -85 -78 -173 -431 l-81
    -327 -570 -5 c-635 -6 -597 -1 -666 -78 -61 -68 -63 -81 -63 -442 0 -361 2
    -374 64 -443 75 -83 -63 -77 1539 -77 1571 0 1460 -5 1530 63 19 18 43 50 55
    72 21 39 22 51 22 365 l0 325 -164 410 c-90 226 -174 431 -187 456 -31 63 -69
    106 -115 129 -37 19 -61 20 -581 19 -299 0 -550 -3 -558 -6z m480 -633 l0
    -320 -179 0 c-221 0 -261 12 -261 79 0 22 115 460 132 505 17 44 57 55 191 56
    l117 0 0 -320z m443 307 c31 -13 41 -34 192 -393 l160 -379 3 -155 c2 -97 -1
    -169 -8 -193 -18 -62 -42 -67 -308 -67 -236 0 -284 6 -302 40 -6 12 -10 236
    -10 589 l0 571 120 0 c79 0 132 -5 153 -13z m-2070 -819 c15 -17 17 -42 17
    -173 0 -140 -2 -153 -20 -170 -28 -25 -76 -23 -103 4 -21 20 -22 31 -22 170 0
    156 4 173 50 191 27 11 56 3 78 -22z m314 10 c25 -20 35 -85 32 -206 -4 -109
    -6 -124 -26 -143 -29 -29 -77 -29 -106 0 -21 20 -22 31 -22 170 0 156 4 173
    50 191 21 9 52 4 72 -12z m328 -9 c18 -17 20 -35 23 -147 4 -147 -8 -197 -52
    -208 -45 -11 -76 4 -93 43 -20 50 -16 281 7 308 32 38 78 40 115 4z"/>
    <path d="M4608 2717 c-18 -8 -153 -180 -398 -506 -336 -450 -370 -498 -370
    -533 0 -25 7 -45 20 -58 19 -19 33 -20 328 -20 253 0 318 3 363 16 145 43 277
    148 343 273 62 118 66 150 66 484 0 175 -4 306 -10 317 -5 10 -24 23 -41 29
    -43 15 -266 13 -301 -2z"/>
    <path d="M560 1261 c-118 -38 -202 -93 -274 -180 -52 -62 -72 -99 -101 -185
    -32 -96 -36 -232 -10 -323 43 -148 147 -280 274 -347 134 -70 42 -66 1511 -66
    1469 0 1377 -4 1511 66 128 67 236 206 274 350 20 77 19 225 -1 295 -54 184
    -188 323 -367 384 l-76 25 -1343 -1 c-1263 0 -1346 -1 -1398 -18z m408 -327
    c153 -63 191 -267 71 -381 -91 -87 -227 -87 -318 0 -149 142 -49 396 157 397
    29 0 69 -7 90 -16z m720 0 c85 -35 142 -120 142 -214 0 -163 -167 -277 -315
    -216 -90 38 -145 120 -145 216 0 94 55 177 140 214 46 20 131 20 178 0z m720
    0 c153 -63 191 -267 71 -381 -91 -87 -227 -87 -318 0 -149 142 -49 396 157
    397 29 0 69 -7 90 -16z m720 0 c86 -35 142 -119 142 -211 -1 -207 -240 -311
    -389 -170 -149 142 -49 396 157 397 29 0 69 -7 90 -16z"/>
    </g>
    </svg>`;
        return svg;
    }

    static suv(flip: boolean, colour: string) {
        let svg = `<?xml version="1.0" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"
 "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="40" height="40" viewBox="0 0 512.000000 512.000000"
 preserveAspectRatio="xMidYMid meet">`;

        if (flip == true) {
            svg += `<g transform="translate(0.000000,0.000000) scale(0.100000,0.100000)" `;
        } else {
            svg += '<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" ';
        }
        svg +=
            ` fill='` +
            colour +
            `' stroke="black"  stroke-width="50" >    
<path d="M263 3720 c-17 -10 -37 -28 -42 -39 -24 -45 -3 -129 38 -151 11 -5
47 -10 80 -10 34 0 61 -2 61 -5 0 -3 -13 -27 -30 -53 -62 -102 -190 -401 -190
-446 0 -10 26 -15 98 -19 133 -7 183 -27 258 -101 76 -76 98 -133 92 -239 -6
-125 -73 -222 -187 -275 -50 -24 -71 -27 -198 -30 l-143 -4 0 -68 c0 -203 89
-354 257 -432 60 -28 79 -32 180 -36 l113 -5 0 50 c0 239 206 492 465 569 41
12 93 18 165 18 120 0 187 -16 295 -72 100 -51 220 -173 268 -273 43 -87 67
-174 67 -241 l0 -48 650 0 650 0 0 48 c0 238 207 491 465 568 41 12 93 18 165
18 120 0 187 -16 295 -72 100 -51 220 -173 268 -273 43 -87 67 -174 67 -242
l0 -48 204 3 204 3 44 30 c24 17 54 51 68 75 23 41 25 58 28 181 l4 137 -194
5 c-148 3 -204 8 -240 22 -62 22 -142 95 -176 159 -23 44 -27 63 -27 136 0 73
4 92 27 136 15 28 50 72 79 98 28 26 50 48 48 50 -2 1 -136 26 -297 55 l-294
53 -47 -26 c-26 -14 -79 -30 -118 -36 -84 -13 -2628 -10 -2655 4 -24 11 -277
352 -300 404 -47 105 -33 198 49 329 31 48 58 94 60 101 4 9 -64 12 -318 12
-303 0 -326 -1 -356 -20z m1618 -1089 c23 -23 29 -38 29 -71 0 -33 -6 -48 -29
-71 l-29 -29 -136 0 c-83 0 -145 5 -161 12 -48 22 -68 88 -41 137 24 43 51 50
199 51 l139 0 29 -29z m1171 0 c27 -24 33 -36 33 -71 0 -35 -6 -47 -33 -71
l-32 -29 -140 0 -140 0 -32 29 c-27 24 -33 36 -33 71 0 35 6 47 33 71 l32 29
140 0 140 0 32 -29z"/>
<path d="M1126 3646 c-94 -134 -116 -175 -116 -219 0 -54 17 -85 121 -220 l91
-118 45 3 46 3 94 320 c51 176 93 321 93 323 0 1 -70 2 -155 2 l-154 0 -65
-94z"/>
<path d="M1705 3728 c-3 -7 -43 -145 -89 -306 -47 -161 -88 -302 -91 -313 -6
-19 4 -19 444 -19 307 0 451 3 451 10 0 9 -101 368 -161 573 l-20 67 -265 0
c-203 0 -266 -3 -269 -12z"/>
<path d="M2450 3733 c0 -12 178 -634 183 -639 2 -2 228 -3 502 -2 l499 3 -226
226 c-322 323 -414 387 -588 409 -89 11 -370 13 -370 3z"/>
<path d="M126 2773 c-8 -28 -28 -204 -24 -209 11 -10 132 -16 194 -9 59 6 73
12 101 40 28 28 33 40 33 80 0 40 -5 52 -34 81 l-34 34 -115 0 c-101 0 -116
-2 -121 -17z"/>
<path d="M4614 2636 c-28 -28 -34 -42 -34 -76 0 -34 6 -48 34 -76 l34 -34 166
0 c91 0 166 3 166 6 0 17 -65 125 -101 167 l-41 47 -95 0 c-95 0 -95 0 -129
-34z"/>
<path d="M1145 2223 c-196 -70 -305 -234 -292 -440 12 -199 160 -362 360 -395
187 -31 376 71 459 247 23 51 31 84 35 148 12 183 -74 335 -234 414 -71 35
-84 38 -177 41 -77 2 -113 -2 -151 -15z m222 -224 c111 -54 155 -195 90 -290
-12 -18 -39 -46 -60 -63 -36 -29 -45 -31 -117 -31 -72 0 -81 2 -117 31 -77 63
-106 137 -83 219 35 124 174 189 287 134z"/>
<path d="M3705 2223 c-196 -70 -305 -234 -292 -440 19 -306 343 -491 622 -354
176 87 275 309 220 496 -38 131 -107 215 -222 272 -71 35 -84 38 -177 41 -77
2 -113 -2 -151 -15z m222 -224 c111 -54 155 -195 90 -290 -12 -18 -39 -46 -60
-63 -36 -29 -45 -31 -117 -31 -72 0 -81 2 -117 31 -77 63 -106 137 -83 219 35
124 174 189 287 134z"/>
</g>
</svg>`;
        return svg;
    }

    static car(flip: boolean, colour: string) {
        let svg = `<?xml version="1.0" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"
 "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="40" height="40" viewBox="0 0 512.000000 512.000000"
 preserveAspectRatio="xMidYMid meet">`;

        if (flip == true) {
            svg += `<g transform="translate(0.000000,0.000000) scale(0.100000,0.100000)" `;
        } else {
            svg += '<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" ';
        }
        svg +=
            ` fill='` +
            colour +
            `' stroke="black"  stroke-width="50" >
<path d="M1465 4106 c-61 -19 -122 -53 -163 -91 -21 -18 -157 -173 -302 -344
l-265 -310 -207 -1 c-188 0 -213 -2 -265 -22 -81 -30 -171 -121 -202 -202 -21
-58 -22 -70 -19 -380 l3 -321 32 -65 c79 -162 223 -250 407 -250 l91 0 1 133
c0 119 3 139 28 202 99 255 332 418 596 418 265 0 497 -163 596 -418 25 -63
28 -83 28 -202 l1 -133 815 0 815 0 1 133 c0 119 3 139 28 202 99 255 332 418
596 418 265 0 497 -163 596 -418 25 -63 28 -83 28 -202 l1 -133 47 0 c121 0
261 103 307 224 21 57 22 71 19 330 -3 263 -4 272 -27 316 -55 104 -128 165
-231 193 -30 9 -262 53 -515 98 l-460 83 -415 345 c-307 255 -432 352 -480
375 l-65 31 -690 2 c-538 2 -699 -1 -730 -11z m269 -219 c57 -38 61 -55 61
-252 0 -156 -2 -185 -18 -208 -39 -60 -46 -62 -342 -65 -168 -2 -281 1 -298 7
-33 13 -45 53 -24 84 26 38 355 419 374 432 27 19 59 24 145 21 51 -2 85 -8
102 -19z m1058 14 c33 -8 218 -147 543 -408 66 -54 77 -81 45 -113 -21 -21
-23 -21 -613 -18 -547 3 -595 4 -620 21 -55 36 -62 59 -65 215 -2 79 -1 164 3
188 8 53 45 100 88 113 41 12 570 13 619 2z m-370 -751 c115 -32 115 -188 0
-220 -48 -13 -156 -13 -204 0 -112 32 -116 187 -5 219 44 13 164 13 209 1z"/>
<path d="M1066 2749 c-170 -40 -336 -208 -375 -379 -19 -84 -13 -228 13 -301
59 -167 204 -301 366 -338 65 -15 206 -13 269 4 177 47 330 202 370 375 15 63
13 206 -3 265 -47 180 -190 323 -367 370 -60 16 -212 18 -273 4z m222 -295
c85 -35 142 -120 142 -214 0 -129 -101 -230 -230 -230 -202 0 -306 242 -167
389 64 67 171 90 255 55z"/>
<path d="M3946 2749 c-170 -40 -336 -208 -375 -379 -19 -84 -13 -228 13 -301
59 -167 204 -301 366 -338 65 -15 206 -13 269 4 177 47 330 202 370 375 15 63
13 206 -3 265 -47 180 -190 323 -367 370 -60 16 -212 18 -273 4z m222 -295
c85 -35 142 -120 142 -214 0 -203 -242 -306 -389 -167 -149 142 -49 396 157
397 29 0 69 -7 90 -16z"/>
</g>
</svg>`;
        return svg;
    }

    static atv(flip: boolean, colour: string) {
        let svg = `<?xml version="1.0" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"
 "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="40" height="40" viewBox="0 0 512.000000 512.000000"
 preserveAspectRatio="xMidYMid meet">`;

        if (flip == true) {
            svg += `<g transform="translate(0.000000,0.000000) scale(0.100000,0.100000)" `;
        } else {
            svg += '<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" ';
        }
        svg +=
            ` fill='` +
            colour +
            `' stroke="black"  stroke-width="50" >
<path d="M1539 4290 c-42 -12 -75 -38 -93 -73 -21 -40 -166 -764 -166 -829 0
-32 9 -66 25 -98 l25 -50 -462 0 c-441 0 -464 -1 -495 -20 -18 -10 -39 -30
-48 -43 -8 -13 -85 -181 -170 -372 -170 -384 -178 -411 -134 -482 41 -67 47
-68 412 -71 250 -2 328 -6 324 -15 -2 -7 -12 -37 -22 -68 l-18 -57 -111 -4
c-175 -8 -300 -64 -428 -192 -79 -80 -148 -208 -168 -313 -19 -99 -9 -264 22
-351 72 -200 243 -356 448 -409 85 -21 235 -21 320 0 228 59 405 237 465 468
20 78 20 228 0 314 -29 127 -139 295 -234 358 l-23 15 42 127 42 126 45 -3 46
-3 166 -365 c92 -201 172 -375 179 -388 7 -13 28 -32 45 -42 31 -19 58 -20
912 -20 847 0 881 1 911 19 22 14 102 130 280 410 l249 391 52 0 51 0 42 -126
42 -126 -23 -15 c-62 -41 -142 -141 -184 -228 -52 -108 -66 -170 -66 -291 0
-142 32 -248 109 -361 194 -286 593 -365 884 -174 120 79 208 190 255 322 35
96 43 268 19 372 -42 180 -179 347 -351 428 -88 41 -168 59 -265 59 l-86 0
-18 57 c-10 32 -21 63 -23 70 -4 9 74 13 324 15 365 3 371 4 412 71 38 62 30
115 -45 283 -116 263 -149 319 -239 409 -84 84 -153 130 -255 172 -116 46
-174 53 -491 53 l-296 0 -344 482 c-189 266 -359 500 -377 520 -20 21 -50 42
-70 48 -44 12 -1403 12 -1443 0z m1633 -749 c269 -378 315 -447 305 -461 -31
-42 -241 -290 -246 -290 -4 0 -56 49 -116 110 l-109 110 31 32 c82 85 67 210
-30 257 -51 24 -85 26 -130 7 -18 -8 -112 -94 -209 -192 -148 -150 -177 -185
-183 -216 -20 -107 45 -188 150 -188 53 0 77 10 120 51 l31 29 122 -123 123
-124 -83 -101 -83 -101 -368 0 -367 -1 -267 535 -268 535 48 242 c27 134 53
264 59 291 l10 47 571 -2 571 -3 318 -444z m-2418 -1762 c69 -25 143 -91 181
-161 27 -48 30 -61 30 -148 0 -112 -20 -164 -91 -235 -204 -203 -545 -72 -562
215 -6 105 22 175 97 251 95 95 223 124 345 78z m3843 -1 c80 -29 162 -112
192 -193 31 -82 26 -187 -13 -263 -125 -246 -464 -246 -593 0 -25 47 -28 63
-28 148 0 84 3 101 27 146 34 65 114 137 181 163 71 27 160 27 234 -1z"/>
</g>
</svg>`;
        return svg;
    }

    static tractor(flip: boolean, colour: string) {
        let svg = `<?xml version="1.0" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"
 "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="40" height="40" viewBox="0 0 512.000000 512.000000"
 preserveAspectRatio="xMidYMid meet">`;

        if (flip == true) {
            svg += `<g transform="translate(0.000000,0.000000) scale(0.100000,0.100000)" `;
        } else {
            svg += '<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" ';
        }
        svg +=
            ` fill='` +
            colour +
            `' stroke="black"  stroke-width="50" >
        <path d="M716 4599 c-24 -19 -26 -26 -26 -98 0 -129 -92 -116 845 -116 937 0
845 -13 845 116 0 131 87 119 -845 119 -786 0 -792 0 -819 -21z"/>
<path d="M815 4298 c-6 -17 -345 -1236 -345 -1242 0 -2 -81 -75 -180 -161
l-180 -157 27 -37 c16 -21 48 -65 73 -99 25 -34 49 -62 54 -62 4 0 42 23 84
50 369 247 849 278 1245 80 246 -124 456 -334 572 -575 97 -199 130 -360 122
-593 -3 -86 -8 -167 -12 -179 l-7 -23 604 0 604 0 12 77 c28 179 111 347 234
478 128 136 275 223 453 271 106 28 333 26 438 -4 42 -12 82 -22 87 -22 14 0
13 479 -1 535 -14 55 -67 118 -116 138 -21 8 -156 34 -300 57 l-263 43 0 226
c0 253 -3 265 -65 277 l-35 6 0 127 1 126 59 79 c66 88 75 121 35 136 -14 5
-30 7 -37 4 -7 -3 -43 -46 -80 -96 l-68 -92 0 -142 0 -142 -35 -6 c-61 -12
-65 -26 -65 -254 l0 -204 -27 6 c-16 3 -255 42 -533 87 -278 45 -505 82 -506
83 0 0 -90 273 -200 606 l-200 605 -722 3 c-573 2 -724 0 -727 -10z m1409
-716 l166 -497 0 -263 0 -262 -128 0 -128 0 -12 56 c-6 31 -30 95 -53 143 -34
69 -58 102 -123 166 -90 90 -173 139 -296 176 -71 22 -95 23 -476 27 l-401 3
63 257 c34 141 85 355 114 475 l52 217 528 0 528 0 166 -498z"/>
<path d="M874 2576 c-409 -67 -736 -363 -846 -766 -20 -74 -23 -108 -23 -265
0 -209 15 -284 89 -441 61 -128 116 -206 216 -304 534 -522 1432 -329 1701
365 87 224 92 494 14 724 -115 339 -412 600 -770 677 -98 21 -283 26 -381 10z
m361 -609 c330 -157 365 -612 61 -809 -288 -186 -659 -21 -718 319 -38 222
106 443 337 520 26 8 75 12 141 10 93 -3 108 -7 179 -40z"/>
<path d="M947 1816 c-99 -36 -170 -119 -186 -218 -28 -170 83 -317 253 -335
114 -12 233 56 282 162 31 66 33 170 3 235 -59 132 -220 203 -352 156z"/>
<path d="M4292 1969 c-313 -40 -562 -271 -626 -581 -81 -391 161 -770 555
-869 78 -19 269 -17 349 4 264 70 466 274 531 536 31 122 24 302 -15 416 -91
268 -326 459 -606 494 -93 12 -97 12 -188 0z m208 -405 c227 -73 306 -373 144
-553 -151 -168 -408 -152 -540 35 -42 59 -69 158 -61 224 18 153 143 285 289
308 61 10 104 6 168 -14z"/>
<path d="M4315 1401 c-176 -81 -119 -341 75 -341 185 0 244 258 78 339 -54 26
-100 26 -153 2z"/>
</g>
</svg>`;
        return svg;
    }
}
